import { Column, Line } from "../style";
import { Skeleton } from "@mui/material";
import { returnNumberWithDot } from "../utils";
import { useNavigate } from 'react-router-dom';
import { DashboardCard } from "../DashboardCard";
import { FiAlertTriangle } from "react-icons/fi";
import { useGlobal } from "../../../hooks/global";
import { FaCheckCircle, FaHourglassHalf } from "react-icons/fa";
import { DashboardChartDoughnut } from "../DashboardChartDoughnut";
import { inactiveItens, primary, secondary, success } from "../../../theme";
import { BiCheckCircle } from "react-icons/bi";
import { TopCard } from "../TopCard";
import { useApi } from "../../../hooks/api";
import { StatusLineChart } from "../StatusLineChart";

interface IReservationsCardProps {
    statisticsPerStatus: { [key: string]: number }
    statisticsPerOrigin: { [key: string]: number }
    reservationInfos: { max: number; min: number; avg: number; }
    loading: boolean
    totalAccomoddation?: number | null
    chartTemporalData?:any
}

const CardWithIcon = ({ icon, subTitle, value, background, link }: any) => {
    const { theme } = useGlobal();

    const navigate = useNavigate();

    return (
        <Line onClick={() => navigate(link)} style={{ gap: 10, alignItems: "center", cursor: "pointer" }}>
            <div>
                <div
                    style={{
                        background,
                        padding: 10,
                        borderRadius: "50%",
                        height: 60,
                        width: 60,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {icon}
                </div>
            </div>
            <Column style={{ color: inactiveItens[theme] }}>
                <div style={{ fontSize: 35, fontWeight: 600 }}>
                    {value}
                </div>
                <div style={{ fontSize: 14, marginTop: -5 }}>{subTitle}</div>
            </Column>
        </Line>
    );
};

const reservation_infos = [
    {
        subTitle: "Realizadas",
        attribute: "done",
        color: "#52C41A",
        icon: <FaCheckCircle color="#FFF" size={26} />,
    },
    {
        subTitle: "Pendentes",
        attribute: "pending",
        color: "#FAAD14",
        icon: <FaHourglassHalf color="#FFF" size={26} />,
    },
    {
        subTitle: "Em Atraso",
        attribute: "late",
        color: "#FF6B6B",
        icon: <FiAlertTriangle color="#FFF" size={26} />,
    },
];

const status_mapper: any = {
    'BOOKED': {
        'title': 'Reservado',
        'color': '#52C41A',
    },
    'CANCELED': {
        'title': 'Cancelado',
        'color': '#CCCCCC',
    },
    'RESERVED': {
        'title': 'Pré-reserva',
        'color': '#FAAD14',
    },
    'BLOCKED': {
        'title': 'Bloqueado',
        'color': '#FF6B6B',
    }
}

const origin_mapper: any = {
    'EXTERNAL API': {
        title: 'API EXTERNA',
        color: '#CCCCCC',
    },
    'API AIRBNB': {
        title: 'AIRBNB',
        color: '#ED6665',
    },
    'API BOOKING.COM': {
        title: 'BOOKING',
        color: '#183B79',
    },
    'API DECOLAR': {
        title: 'DECOLAR',
        color: '#5924E9',
    },
    'API EXPEDIA': {
        title: 'EXPEDIA',
        color: '#F3C244',
    },
    'CASA TEMPORADA': {
        color: '#C23041',
    },
    'API GOOGLEVR': {
        color: '#34A853',
    },
    'TEMPORADA LIVRE': {
        color: '#439AC5',
    },
    'VRBO': {
        color: '#122248',
    },
    'YUCA': {
        color: '#333333',
    },
    'HOUSI': {
        color: '#DD4B70',
    },
    'HOMES & VILLAS': {
        color: '#EA996E',
    },
    'DESCONHECIDO': {
        title: 'STAYS',
        color: '#3EBCE2',
    },
    'WEBSITE': {
        color: '#333333',
    },
}

export const ReservationsCard: React.FC<IReservationsCardProps> = ({ chartTemporalData, reservationInfos, statisticsPerOrigin, statisticsPerStatus, loading, totalAccomoddation }) => {
    const { theme } = useGlobal();
    const { user } = useApi();

    if (loading) return (
        <>
            {user?.is_root && (
                <Line style={{ gap: 30, flexWrap: "wrap" }}>
                    <Skeleton
                        variant="rectangular"
                        animation="wave"
                        style={{ minWidth: 250, borderRadius: 5, flex: 1, height: 108 }}
                    />
                </Line>
            )}
            <Line style={{ gap: 30, flexWrap: "wrap" }}>
                <Skeleton
                    variant="rectangular"
                    animation="wave"
                    style={{ minWidth: 250, borderRadius: 5, flex: 1, height: 317 }}
                />

                <Skeleton
                    variant="rectangular"
                    animation="wave"
                    style={{ minWidth: 250, borderRadius: 5, flex: 1, height: 317 }}
                />

                <Skeleton
                    variant="rectangular"
                    animation="wave"
                    style={{ minWidth: 250, borderRadius: 5, flex: 1, height: 317 }}
                />
            </Line>
        </>
    )

    return (
        <>
            <Line style={{ color: secondary[theme], gap: 30, flexWrap: "wrap" }}>
                {user?.is_root && typeof totalAccomoddation === "number" && (
                    <TopCard
                        icon={<BiCheckCircle size={40} />}
                        title="Total de acomodações"
                        value={totalAccomoddation}
                        containerStyle={{ color: success }}
                        tooltip={
                            totalAccomoddation +
                            ` acomodações com status "ativo" ou "ativo porém oculto"`
                        }
                    />
                )}
            </Line>
            <Line style={{ color: secondary[theme], gap: 30, flexWrap: "wrap" }}>
                {user?.is_root && (
                    <>
                    <StatusLineChart chartTemporalData={chartTemporalData}/>
                        {/*LineCharts.map(({ title, attribute }) => (
                            <Line key={title}>
                                <DashboardCharLine
                                    key={title}
                                    theme={theme}
                                    title={title}
                                    infos={statistics[attribute].per_days}
                                    labels={statistics.days}
                                    minWidth={250}
                                    total={statistics[attribute].per_days[0].values.reduce(
                                        (a: number, b: number) => a + b,
                                        0
                                    )}
                                    mask={mask}
                                />
                            </Line>
                        ))*/}
                    </>
                )}
            </Line>
            <Line style={{ color: secondary[theme], gap: 30, flexWrap: "wrap" }}>
                <DashboardChartDoughnut
                    theme={theme}
                    title={'Reservas por Origem'}
                    infos={Object.values(statisticsPerOrigin)}
                    labels={Object.keys(statisticsPerOrigin).map((key) => origin_mapper?.[key?.toUpperCase().trim()]?.title ?? key)}
                    colors={Object.keys(statisticsPerOrigin).map((key) => origin_mapper?.[key?.toUpperCase().trim()]?.color ?? key)}
                    minWidth={250}
                />
                <DashboardChartDoughnut
                    theme={theme}
                    title={'Reservas por Status'}
                    infos={Object.values(statisticsPerStatus)}
                    labels={Object.keys(statisticsPerStatus).map((key) => status_mapper?.[key]?.title ?? key)}
                    colors={Object.keys(statisticsPerStatus).map((key) => status_mapper?.[key]?.color ?? key)}
                    minWidth={250}
                />
                <DashboardCard
                    minWidth={250}
                    title="Check-ins por status"
                    theme={theme}
                >
                    <Column
                        style={{
                            background: primary[theme],
                            padding: 20,
                            gap: 20,
                            flex: 1,
                            borderBottomLeftRadius: 5,
                            borderBottomRightRadius: 5,
                            justifyContent: "space-between",
                        }}
                    >
                        {reservation_infos.map(({ subTitle, attribute, icon, color }) => (
                            <CardWithIcon
                                key={subTitle}
                                icon={icon}
                                subTitle={subTitle}
                                value={returnNumberWithDot(reservationInfos[attribute as 'max' | 'min' | 'avg']).split(',')[0]}
                                background={color}
                                link={`/reservations?status=${attribute}`}
                            />
                        ))}
                    </Column>
                </DashboardCard>
            </Line>
        </>
    )
}